import { render, staticRenderFns } from "./modalINSSReclamada.vue?vue&type=template&id=5f2997d1&scoped=true&"
import script from "./modalINSSReclamada.vue?vue&type=script&lang=js&"
export * from "./modalINSSReclamada.vue?vue&type=script&lang=js&"
import style0 from "./modalINSSReclamada.vue?vue&type=style&index=0&id=5f2997d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2997d1",
  null
  
)

export default component.exports